import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import selectTabs from '../select-tabs/select-tabs.vue'
import { IKeywords, IKeywordsGeneral, IKeywordsReport, ISession } from '@/types'
import { mapState } from 'vuex';

@Component({
  computed: mapState({
    ServiceId: (state: {session: ISession}) => state.session.serviceId,
  }),
  components: {
    selectTabs
  }
})

export default class Serpbook extends Vue {

  [key: string]: any;
  
  private namespace: string = '/GeneralReport';

  private ServiceId!: number;

  private topKeywords: IKeywordsReport[] | null = null;

  private extraKeywordsGeneral: IKeywordsGeneral[] | null = null;

  private serpbookChange: string = 'monthlyChange';

  private serpbookTab: number = 2;

  private isOpen: boolean = false;

  private loading: boolean = false;

  private error: boolean = false;

  private scrollPosition: number | null = null;

  private resizeWidth: number = 1080;

  private position: number | null = null;

  private debounceTimeout: boolean = false;

  private get TableHeadings () {

    return [
      {
        title: this.$t('overview.serpbook.th1'),
        className: 'col-4',
      },
      {
        title: this.$t('overview.serpbook.th2'),
      },
      {
        title: this.$t('overview.serpbook.th3'),
      },
      {
        title: this.$tc('overview.serpbook.th4', this.serpbookTab + 1),
      },
      {
        title: this.$t('overview.serpbook.th5')
      }
    ];
  }

  created () {

    this.$nextTick(() => {
      document.addEventListener('scroll', this.documentScroll);
      window.addEventListener('resize', this.documentResize);
    });
  }

  mounted () {
    
    this.resizeWidth = (this.$refs.serpbook as HTMLElement).offsetWidth;
  }

  updated () {
    
    this.position = (this.$refs.serpbooknav as HTMLElement).offsetTop;
  }

  destroyed () {

    document.removeEventListener('scroll', this.documentScroll);
    window.removeEventListener('resize', this.documentResize);
  }
 
  private documentScroll () {

    if (!this.debounceTimeout) {

      this.debounceTimeout = !this.debounceTimeout;
      setTimeout(() => this.debounceTimeout = !this.debounceTimeout, 200);

      this.scrollPosition = window.scrollY;
    }
  }

  private documentResize () {

    this.resizeWidth = (this.$refs.serpbook as HTMLElement).offsetWidth;
  }

  private getExtraKeywordsDetails () {

    if (this.extraKeywordsGeneral != null) {

      let requestLength = this.extraKeywordsGeneral.length;

      this.loading = true;

      this.extraKeywordsGeneral.forEach((group: IKeywordsGeneral, i: number) => {

        this.$axios.get(`${this.$apiUrl + this.namespace}/ExtraKeywords/Details`, {
          params: {
            serviceId: this.ServiceId,
            keywordsGroupId: group.keywordsGroupId
          }
        })
          .then(result => {

            requestLength--;

            if (requestLength <= 0) {

              this.loading = false;
            }

            if (this.extraKeywordsGeneral != null) {
  
              this.$set(this.extraKeywordsGeneral[i], 'details', result.data);
            }
          })
          .catch(error => {

            // Error...
          });
      })
    }
  }

  private async getReports (endpoint: string) {
    
    this.error = false;

    const property: string = endpoint.charAt(1).toLowerCase() + endpoint.substring(2).replace(/\/|-/g, '');

    try {
      
      const response = await this.$axios.get(`${this.$apiUrl + this.namespace + endpoint}`, {
        params: {serviceId: this.ServiceId}
      });
      
      if (response.data == null) {

        throw new Error('No content');
      }

      this[property] = response.data;

    } catch (err) {

      this.error = true;
      console.log(err);
    }
  }

  private getExtraKeywordsGeneral () {

    if (this.extraKeywordsGeneral != null) {

      return this.isOpen = !this.isOpen;
    }

    this.getReports('/ExtraKeywords/General');

    return this.isOpen = true;
  }

  private setSerpbookChange ({ type, index }: { type: string, index: number, length: number }) {

    const allowedChange = ['dailyChange', 'weeklyChange', 'monthlyChange'];

    if ('serpbook' === type) {

      this.serpbookTab = index;
      this.serpbookChange = allowedChange[index];
    }
  }

  private checkProgress (value: number) {

     return value === 0
      ? `<span>${value} <i class="mdi mdi-arrow-right-bold" area-hidden="true"></i></span>`
      : value < 0
        ? `<span class="text-danger-light">${value} <i class="mdi mdi-arrow-down-bold" area-hidden="true"></i></span>`
        : `<span class="text-success">${value} <i class="mdi mdi-arrow-up-bold" area-hidden="true"></i></span>`;
  }

  @Watch('ServiceId', {immediate: true})
  private getSerpbook (next: number, prev: number | undefined) {

    if (next != undefined) {
      
      this.topKeywords = null;
      this.extraKeywordsGeneral = null;
      this.position = null;
      this.isOpen = false;
      this.getReports('/TopKeywords');
    }
  }

  @Watch ('extraKeywordsGeneral')
  fetchKeywordsExtra (next: IKeywordsGeneral[], prev: IKeywordsGeneral[]) {
    console.log(next)
    if (next != null) {

      this.getExtraKeywordsDetails();
    }
  }
}